// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6edae1c4","455":"eb899717","885":"8be3d829","977":"8db5507b"}[chunkId] + ".chunk.js";
};